import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

// Get google ad manager ad units
export const getGoogleAdManagerAdUnitsSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnits.results,
  results => results
)

export const getGoogleAdManagerAdUnitsIsLoadingSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnits.isLoading,
  isLoading => isLoading
)

export const getGoogleAdManagerAdUnitsErrorSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnits.error,
  error => error
)

export const getGoogleAdManagerAdUnitsWasLoadedSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnits.wasLoaded,
  wasLoaded => wasLoaded
)

// Get google ad manager ad unit
export const getGoogleAdManagerAdUnitSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnit.data,
  data => data
)

export const getGoogleAdManagerAdUnitIsLoadingSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnit.isLoading,
  isLoading => isLoading
)

export const getGoogleAdManagerAdUnitErrorSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnit.error,
  error => error
)

export const getGoogleAdManagerAdUnitWasLoadedSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.googleAdManagerAdUnit.wasLoaded,
  wasLoaded => wasLoaded
)

// Get onsite rates
export const getOnsiteRatesSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.onsiteRates.results,
  results => results
)

export const getOnsiteRatesIsLoadingSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.onsiteRates.isLoading,
  isLoading => isLoading
)

export const getOnsiteRatesErrorSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.onsiteRates.error,
  error => error
)

export const getOnsiteRatesWasLoadedSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.onsiteRates.wasLoaded,
  wasLoaded => wasLoaded
)

// Create bulk gam line items
export const createBulkGamLineItemsSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createBulkGamLineItems.data,
  data => data
)

export const createBulkGamLineItemsIsLoadingSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createBulkGamLineItems.isLoading,
  isLoading => isLoading
)

export const createBulkGamLineItemsErrorSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createBulkGamLineItems.error,
  error => error
)

export const createBulkGamLineItemsWasCreatedSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createBulkGamLineItems.wasCreated,
  wasCreated => wasCreated
)

// Create gam line item forecast
export const createGamLineItemForecastSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createGamLineItemForecast.data,
  data => data
)

export const createGamLineItemForecastIsLoadingSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createGamLineItemForecast.isLoading,
  isLoading => isLoading
)

export const createGamLineItemForecastErrorSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createGamLineItemForecast.error,
  error => error
)

export const createGamLineItemForecastWasCreatedSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.createGamLineItemForecast.wasCreated,
  wasCreated => wasCreated
)

// Get gam ad units
export const gamAdUnitSizesSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.getGamAdUnitSizes.results,
  results =>
    results
      .filter(({ is_audio }) => !is_audio)
      .slice()
      .sort((a, b) => a.size.width - b.size.width)
      .map(({ size }) => size)
)

export const getGamAdUnitSizesIsLoadingSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.getGamAdUnitSizes.isLoading,
  isLoading => isLoading
)

export const getGamAdUnitSizesErrorSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.getGamAdUnitSizes.error,
  error => error
)

export const getGamAdUnitSizesWasLoadedSelector = createSelector(
  ({ googleAdManager }) => googleAdManager.getGamAdUnitSizes.wasLoaded,
  wasLoaded => wasLoaded
)
